import axios from "axios";
import { apiUrl } from "../components/Settings/Config";

// HRMS backend routes are mounted at /api/employee/* (see api/app.js),
// not under /apiv1/* like the rest of Neemo, so this instance points at
// the sibling "/api/" base derived from the same host as apiUrl.
const empApiUrl = apiUrl.replace(/apiv1\/?$/, "api/");

const empApi = axios.create({
  baseURL: empApiUrl,
});

// Same token-based auth as utils/axios.js: HRMS screens are reached
// through Neemo's existing login/session, not a separate employee login.
empApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `${token}`;
    }
    if (config.data instanceof FormData) {
      config.headers["Content-Type"] = "multipart/form-data";
    } else {
      config.headers["Content-Type"] = "application/json";
    }
    return config;
  },
  (error) => Promise.reject(error),
);

empApi.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if ((error.response.status === 401 || error.response.status === 403) && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshResponse = await axios.post(`${apiUrl}refresh`, {}, { withCredentials: true });

        const newAccessToken = refreshResponse.data.token;
        localStorage.setItem("token", newAccessToken);

        originalRequest.headers.Authorization = `${newAccessToken}`;
        return empApi(originalRequest);
      } catch (refreshError) {
        console.error("Refresh token failed:", refreshError);
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  },
);

export default empApi;
